import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, ButtonGroup, Button, Collapse } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import { setAuthUserNumber } from '../../actions/authUserAction';
import { setAuthUserSelected, setApplicationAuthUsers } from '../../actions/applicationAction';
import PageValidation from '../../components/PageValidation/PageValidation';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import './AuthorizedUsers.scss';

import FaAngleDown from 'react-icons/lib/fa/angle-down';
import FaAngleUp from 'react-icons/lib/fa/angle-up';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Authorized users',
      event: 'Credit Card Step 5A'
  }
}

class AuthorizedUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addAuthorizedUser:(this.props.application.authUserSelected ? (this.props.application.authUsersNum > 0 ? true: false) : null),
      numUsers: this.props.application.authUsersNum || 0,
      expand: false,
      showPageError: false,
      errorMessage: ""
    }

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.setAddAuthorizedUsers = this.setAddAuthorizedUsers.bind(this);
    this.setNumAuthorizedUsers = this.setNumAuthorizedUsers.bind(this);
    this.expandToggle = this.expandToggle.bind(this);
  }

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs);
  }

  onClickForward(event) {
    event.preventDefault();
    if(this.state.addAuthorizedUser === null) {
      this.setState({
        showPageError: true,
        errorMessage: "Oops, we need to know whether you'd like to add authorized users."
      });
    }
    else if(this.state.addAuthorizedUser && this.state.numUsers === 0) {
      this.setState({
        showPageError: true,
        errorMessage: "Oops, we need to know how many authorized users you'd like to add."
      });
    }
    else {  
      this.props.setAuthUserSelected();
      this.props.setAuthUserNumber(this.state.numUsers);
      this.props.setApplicationAuthUsers(this.state.numUsers);    
      if(this.state.addAuthorizedUser && this.state.numUsers > 0) {      
        this.props.history.replace('/AuthorizedUsers/Add');
      }
      else {
        this.props.history.replace('/Bpi');
      }
    }
  }
  onClickBackward(event) {
    event.preventDefault();

    if (this.props.householdincome !== "") {
      this.props.history.replace('/IncomeExpenses/Finances');
    } else {
      this.props.history.replace('/IncomeExpenses');
    }
  }
  setAddAuthorizedUsers(event) {
    this.setState({
      addAuthorizedUser: (event.target.name === "yes") ? true : false,
      showPageError: false,
      numUsers: 0
    }, () => {
      if(!this.state.addAuthorizedUser) {
        this.props.setApplicationAuthUsers(0);
      }
    });
  }
  setNumAuthorizedUsers(event) {
    this.setState({
      numUsers: parseInt(event.target.name, 10),
      showPageError: false
    }, () => {
      this.props.setAuthUserSelected();
      this.props.setApplicationAuthUsers(this.state.numUsers);
    });
  }
  expandToggle() {
    this.setState({
      expand: !this.state.expand
    })
  }
  render() {
    let expand = <div className="expand" onClick={this.expandToggle}><div>more</div><FaAngleDown /></div>;
    if(this.state.expand) {
      expand = <div className="expand" onClick={this.expandToggle}><div>less</div><FaAngleUp /></div>
    }

    return (
      <div className="authorized-users">     
        <h1>Do you want to add authorized users to this account?</h1>
        <p>An authorized user is someone who has a card (with their own name) on your account. As the person applying for the card, you're the primary cardholder.</p>
        <div className="display-more-separator">
          {expand}
        </div>
        <Collapse isOpen={this.state.expand} className="expanded-content">
          <h2>About authorized users</h2>
          <h3>Your responsibility</h3>
          <p>As the primary cardholder, you’re responsible for all charges to your Visa account. This means that you promise to pay us for all transactions and fees on the account, whether they were incurred by you or an authorized user.</p>
          <h3>Your credit limit</h3>
          <p>If you have authorized users on your account, the total credit limit will be shared among all of the cards.</p>
          {/* PBI 452328: Removed incorrect text about Annual Fees for authorized users */}
          <h3>Customer service</h3>
          <p>Authorized users can contact us to ask questions about your Visa account or report a Visa card that’s been lost or stolen. However, we’ll only take instructions about your Visa cards or Visa account from you.</p>
          <p>Make sure you have the consent of each of your authorized users to provide us with their information in this application.</p>
        </Collapse>
        <Form onSubmit={this.onClickForward}>
          <FormGroup>
            <Label for="addUsers">Add authorized users?</Label>
            <ButtonGroup>
              <Button className={(this.state.addAuthorizedUser === true) ? "active" : ""} name="yes" onClick={this.setAddAuthorizedUsers}>Yes</Button>
              <Button className={(this.state.addAuthorizedUser === false) ? "active" : ""}  name="no" onClick={this.setAddAuthorizedUsers}>No</Button>
            </ButtonGroup>
          </FormGroup>         
          <FormGroup className={(this.state.addAuthorizedUser !== true) ? "hidden": ""}>
            <Label for="numUsers">How many authorized users?</Label>
            <ButtonGroup className="num-users">
              <Button className={(this.state.numUsers === 1) ? "active" : ""} name="1" onClick={this.setNumAuthorizedUsers}>1</Button>
              <Button className={(this.state.numUsers === 2) ? "active" : ""}  name="2" onClick={this.setNumAuthorizedUsers}>2</Button>
              <Button className={(this.state.numUsers === 3) ? "active" : ""}  name="3" onClick={this.setNumAuthorizedUsers}>3</Button>
              <Button className={(this.state.numUsers === 4) ? "active" : ""}  name="4" onClick={this.setNumAuthorizedUsers}>4</Button>
            </ButtonGroup>
          </FormGroup>                           
          <PageValidation visible={this.state.showPageError} message={this.state.errorMessage} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>  
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.incomeExpenses,
  authUsers: state.authUsers,
  application: state.application
});

const mapDispatchToProps = dispatch => ({
  setAuthUserNumber: (num) => dispatch(setAuthUserNumber(num)),
  setAuthUserSelected: () => dispatch(setAuthUserSelected()),
  setApplicationAuthUsers: (numAuthUsers) => dispatch(setApplicationAuthUsers(numAuthUsers)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("auth-users")(AuthorizedUsers));


// WEBPACK FOOTER //
// ./src/containers/AuthorizedUsers/AuthorizedUsers.js